import styled from 'styled-components'
import config from '../../config'

export const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
`

export const NavBarContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  .rdsbottom{
    border-bottom-left-radius: 40px;
  }
  z-index: 2;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 2%;
`

export const TelephoneServiceContainer = styled.div`
  height: auto;
  display: flex;
  padding-left: 10px;
  padding-top: 15px;
  padding-bottom: 15px;
`

export const IconContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const TelephoneTextContainer = styled.div`
  font-family: 'YouYuan';
  font-size: 1rem;
  color: ${config.theme.textColor};
  flex: 5;
`

export const ListContainer = styled.div`
  background-color: white;
  width: 90%;
  height: 100%;
  z-index: 1;
  position: absolute;
  top: 0;
  left: 5%;
`

export const ListTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.125rem;
  font-family: 'YouYuan';
  color: #525252;
  position: absolute;
  top: 17%;
  left: 5%;
  height: 5%;
  font-weight: bold;
`
export const NumberConfirmButton = styled.div`
  border: 1px solid #1199FE;
  font-size: 0.8rem;
  border-radius: 20px;
  color: #1199FE;
  height: 90%;
  display: flex;
  align-items: center !important;
  justify-content: center;
  flex: 1;
`

export const ConfirmButton = styled.button`
  position: absolute;
  margin-left: 35%;
  border: 0px;
  bottom: 20%;
  border-radius: 20px;
  height: 5%;
  text-align: center;
  font-family: 'YouYuan';
  width: 30%;
  background: linear-gradient(to right, #63D5ED, #6E8FF8);
  color: white;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
`

export const DeleteIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
`
